export function indexs(){
	if($(".INDEX").length > 0){
		// swiper
		var swiper = new Swiper('.swiper-container', {
			slidesPerView: 2,
			spaceBetween: 0,
			initialSlide: 0,
			loop: true,
			autoplay: {
				delay: 3000,
				disableOnInteraction: true
			},
			breakpoints: {
				767: {
				  slidesPerView: 1,
				  spaceBetween: 0
				}
			}
		});
	}
	
	// wow---------
    new WOW().init();

	$(function(){
		let counter = 1;
        const slide1 = $(".firstview1");
        const slide2 = $(".firstview2");
		
		
        const photo1 = new Array();
        for(let i=0; i < slide1.find(".hide img").length; i++){
            photo1[i] = slide1.find(".hide img").eq(i).attr("src");
        }
		
		const photo2 = new Array();
        for(let i=0; i < slide2.find(".hide img").length; i++){
            photo2[i] = slide2.find(".hide img").eq(i).attr("src");
        }
		
        const photos1 = Object.entries(photo1).map(([src, value]) => ({'src': value}));
        const photos2 = Object.entries(photo2).map(([src, value]) => ({'src': value}));
		
		
        const vegas1  = slide1.vegas({
            overlay: false,
            timer:false,
			transitionDuration: 5000,
			delay: 5000,
			animation: 'kenburns',
			animationDuration:5000,
			autoplay:false,
            slides: photos1
        });
		 
		const vegas2  = slide2.vegas({
			overlay: false,
			timer:false,
			transitionDuration: 5000,
			delay: 5000,
			animation: 'kenburns',
			animationDuration: 5000,
			autoplay:false,
			slides: photos2
		});
		
		setInterval(function(){
			if(counter % 2 == 0){
				slide1.vegas('play');
				slide2.vegas('pause');
			}else{
				slide2.vegas('play');
				slide1.vegas('pause');
			}
			counter ++;
		},5000);
		
	});	
}